import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AdminService } from 'app/services/admin.service';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { UserService } from 'app/users/user.service';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { AddNewUserRequest, ApplicationTableData, RoleObject, UpdateAccessTypeRequest, UserData } from 'app/models/admin.model';
import { AccessTypesList} from 'app/models/data/mock/admin';
import { FormService } from 'app/services/form.service';
import { ApplicationInfoModel } from 'app/models/application-info.model';

@Component({
  selector: 'app-orgadmin-dashboard',
  templateUrl: './orgadmin-dashboard.component.html',
  styleUrls: ['./orgadmin-dashboard.component.scss']
})
export class OrgAdminDashboardComponent implements OnInit {
  user!: UserProfileRecord;
  userName!: string;
  showResults : boolean = false;
  isSmallView: boolean = false;
  screenSizeSubscription!: Subscription;
  dataSource = new MatTableDataSource<ApplicationTableData>();
  columnsToDisplay: string[] = ['form', 'applicant', 'firstSuggestedName', 'date',
    'negotiator', 'progress', 'viewIcon']; //, 'detailsIcon'
  columnsToDisplayWithStatus: string[] = ['form', 'applicant', 'firstSuggestedName', 'date',
    'negotiator', 'status', 'progress', 'viewIcon'];
  @ViewChild(MatTable) table! : MatTable<any>;
  applicationData!: ApplicationTableData[];
  
  showUsers: boolean = false;
  loadingComplete: boolean = false;
  usersLoadingComplete: boolean = false;
  usersList = new MatTableDataSource<UserData>();
  userColumnsToDisplay: string[] = ['userName', 'email', 'accessType', 'status', 'change', 'remove'];
  userColumnsToDisplaySmallView: string[] = ['userName', 'accessType', 'status', 'detailsIcon'];
  orgId!: string;
  userId!: string;
  userEmail!: string;

  @ViewChild('editAccess') updateAccessDialog!: TemplateRef<any>;
  editAccessDialogRef!: MatDialogRef<any, any>;
  editAccessForm!: FormGroup;
  accessTypesList!: any;
  currentAccessType!: string;
  updateUserEmail!: string;

  @ViewChild('removeUser') removeUserDialog!: TemplateRef<any>;
  removeUserDialogRef!: MatDialogRef<any, any>;
  removeUserEmail!: string;
  removeUserName!: string;

  addUserForm!: FormGroup;
  addUserDialogRef!: MatDialogRef<any, any>;
  @ViewChild('addUser') addUserDialog!: TemplateRef<any>;
  addUserErrorMsg!: string;
  addUserHasError: boolean = false;
  addUserErrorEmail!: string;

  @ViewChild(MatPaginator) paginator!: MatPaginator; 
  appListLength: number = 0;
  defaultAppPageSize: number = 10;
  @ViewChild(MatPaginator) usrPaginator!: MatPaginator;
  userListLength: number = 0;
  userPageSize: number = 10;
  userCurrentPage: number = 0;
  userDataPag !: UserData[];
  userTableData !: UserData[];

  appCardData !: ApplicationTableData[];
  @ViewChild(MatPaginator) cardPaginator!: MatPaginator;
  pageCardSize: number = 10; 
  currentPage: number = 0;
  appCardDataPag !: ApplicationTableData[];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatSort) usersSort!: MatSort;
  formTypeMap = { 
    'A': 'Form A - Single Entity Drug and Salt',
    'B': 'Form B - Single Entity' ,
    'C': 'Form C - Modified Salt Form' ,
    'D': 'Form D - USAN Revised Application' ,
    'E': 'Form E - Contact Lens Material' ,
    'F': 'Form F - Biologics' 
  };
 
  progressRateMap = {
    'DRAFT' : '20',
    'SUBMITTED' : '40',
    'PAYMENT PENDING' : '60',
    'IN REVIEW' : '80',
    'APPROVED' : '100'
  }

  appTypes: string[] = ['Draft', 'Submitted', 'In Review', 'Approved / Closed'];
  draftApps !: ApplicationTableData[];
  submittedApps !: ApplicationTableData[];
  inReviewApps !: ApplicationTableData[];
  approvedOrClosedApps !: ApplicationTableData[];
  hasAnyApplications : boolean = false;
  
  constructor(private router: Router,
    private responsive: BreakpointObserver,
    private sortAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private adminService: AdminService,
    private formService: FormService,
    private alertService: AlertsService
  ) {}


  ngOnInit() {
    this.user = this.userService.profile;
    this.userName = this.user ? this.user.displayName : '';
    let orgId = this.user?.orgId;
    this.orgId = orgId ? orgId : '';
    this.retrieveApplications('Draft');
    this.retrieveUserData();
    this.determineViewMode();
  }

  ngAfterViewInit() {
   setTimeout(() => {
      this.dataSource.paginator = this.paginator;  
    }, 500); 
  } 

  retrieveApplications(appType: string) {
    if(this.orgId) {
      const request = {
        'orgId': this.orgId,
        'status': [appType]
      }; 
      this.adminService.getOrgAdminDashboard(request).subscribe({
        next: res => {
         //console.log('Response data '+ JSON.stringify(res.Data))
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while retrieving data" + res.ErrorMessage);
            this.loadingComplete = true;
          } else {  
            if(res.Data) {
              let results : ApplicationTableData[] = [];
              res.Data.forEach(element => {
                let appRecord : ApplicationTableData = {
                  date: element.opened_at,
                  firstSuggestedName: this.parseFormType(element.u_form_type) !='D'? element.u_suggested_names_in_order_of_preference_for_single_entity
                    :element.u_name_for_which_you_are_requesting_a_revision,
                  form:  this.parseFormType(element.u_form_type),
                  negotiator: element.negotiator?.name,
                  applicant: element.u_applicant,
                  status: element.u_case_status,
                  progress: this.calculateProgress(element.u_case_status),
                  sysId: element.caseSysId,
                  systemId: element.sys_id,
                  caseNumber: this.retrieveCaseNumber(this.parseFormType(element.u_form_type), element)
                };
                results.push(appRecord);
              }); 
              this.dataSource.data = results;
              this.hasAnyApplications = true;
              this.appListLength = this.dataSource.data.length;
              this.cdr.detectChanges();
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.dataSource.sortingDataAccessor = (data, sortColumn) =>{
                const dataValue = data[sortColumn];
                return typeof dataValue === 'string' ? dataValue.toLowerCase() : dataValue;
              }
              this.appCardData = this.dataSource.data;
              this.currentPage = 0;
              this.updateItemsForPagination();
              this.loadingComplete = true;
              this.showResults = true;
            }
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while retrieving data" + error.message);
          this.loadingComplete = true;
        }  
      }); 
    } else {
      console.log('No org Id found for the user');
      this.loadingComplete = true;
    }
  }

  parseFormType(str: string) : string {
    if(str.includes('Form '))
      return str.split('Form ')[1];
    else if(str.includes('Form'))
      return str.split('Form')[1];
    return str;
  }

  retrieveUserData() {
    this.usersLoadingComplete = false;
    if(this.orgId) {
      const request = {
        'orgId': this.orgId
      }; 
      this.userEmail = this.user ? this.user.email : '';
      this.userId = this.user ? this.user.uniqueId : '';
      if(this.userEmail && this.userId) {
        this.adminService.getOrgAdminUsers(this.userEmail, this.userId, request).subscribe({
          next: res => {
          // console.log('Response data '+ JSON.stringify(res.Data))
            if (res.Errors.length > 0) {
              this.alertService.displayError("Error occurred while retrieving user data" + res.ErrorMessage);
              this.usersLoadingComplete = true;
            } else {  
              if(res.Data) {
                let results : UserData[] = [];
                res.Data.forEach(element => {
                  let appRecord : UserData = {
                    userName: element.firstName + ' ' + element.lastName,
                    accessType: this.parseUsanAccessTypeArr(element.role),
                    status: element.userStatus && element.userStatus === 'ACTIVE' ? 'Active' : 'Pending',
                    email: element.emailAddress
                  };
                  results.push(appRecord);
                });
                this.showUsers = true;
                this.usersLoadingComplete = true;
                this.userListLength = results.length;
                this.userTableData = results;
                this.updateUserItemsForPagination();
              }
              this.usersLoadingComplete = true;
            }
          },
          error: error => {
            this.alertService.displayError("Error occurred while retrieving User data" + error.message);
            this.usersLoadingComplete = true;
          }  
        }); 
      } else {
        console.log('No email and uniqueId found for the user');
        this.usersLoadingComplete = true;
      }
    } else {
      console.log('No org Id found for the user');
      this.usersLoadingComplete = true;
    }
  }

  parseUsanAccessType(str: string) : string {
    if(str && str.includes('USAN ')) 
      return str.split('USAN ')[1];
    return str;
  }

  parseUsanAccessTypeArr(roles: any[]) : string {
    const roleNames =  roles
        .map(role => role.roleName.replace(/^USAN\s*/i, '')) 
        .join('/');
    return roleNames;
  }

  calculateProgress(str: string) : string {
    if(str)
      return this.progressRateMap[str.toUpperCase()]
    return str;
  }

  retrieveCaseNumber(str: string, record: any) : string {
    let returnVal = '';
    if(str) {
      let formElementStr = 'usan_form_' + str.toLowerCase();
      Object.keys(record).forEach(key => {
        if(key === formElementStr) {
          returnVal = record[key]?.display_value;
        }
      });
    }
    return returnVal;
  }

  determineViewMode() {
    this.screenSizeSubscription = this.responsive.observe([Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
      Breakpoints.TabletPortrait, Breakpoints.TabletLandscape 
    ])
        .subscribe(result => {
          const breakpoints = result.breakpoints;
          this.isSmallView = false;
          if (breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape] ||
            breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
            this.isSmallView = true;
          } 
        });
  }

  shorten(name: string) : string {
    if(name)
      return name.charAt(0) + '.' + name.substring(name.indexOf(' ') + 1);
    return name;
  }

  viewDetails(row: any) {
    let appInfo = {
      formType: this.formService.prepFormTypeForUpdateCase(row.form),
      formId: row.systemId,
      caseSysId: row.sysId,
      status: row.status
    };
    
    if(row.status === 'Draft' || row.status === 'Payment Pending') {
      this.formService.lockCase(ApplicationInfoModel.parseValues(appInfo)).subscribe();
    }

    this.router.navigate(['/usan/application'], 
      { queryParams : { formType: row.form, id: row.sysId, source: 'orgadmin-dashboard'}});
  }

  openEditAccessPopUp(element: any) {
    this.currentAccessType = '';
    this.accessTypesList = AccessTypesList;
    this.editAccessForm =  new FormGroup ({
      accessTypeSelected : new FormControl('USAN '+element.accessType, Validators.required)  
    });
    this.currentAccessType = 'USAN ' + element.accessType;
    this.updateUserEmail = element.email
    this.editAccessDialogRef = this.dialog.open(this.updateAccessDialog, {
      width: '700px'
    });
    
  }

  get accessTypeField() {
    return this.editAccessForm.get('accessTypeSelected');
  }


  setNewAccessType(newVal: any) {
    this.accessTypeField?.setValue(newVal)
  }

  saveAccessTypeChange() {
    let newAccessType = this.accessTypeField?.value;
    if(newAccessType && this.currentAccessType &&
      newAccessType != this.currentAccessType) {
      let request : UpdateAccessTypeRequest = {
        orgId : this.orgId,
        email : this.updateUserEmail,
        newRole : newAccessType,
        currentRole : this.currentAccessType
      }
      this.adminService.editAccess(request, this.userEmail, this.userId).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while updating User access" + res.ErrorMessage);
          } else {  
            this.alertService.displaySuccess("User access has been updated");
            this.retrieveUserData();
            this.editAccessDialogRef.close();
          }
          
        },
        error: error => {
          this.alertService.displayError("Error occurred while updating User access" + error.message);
        }  
      });
    } else {
      this.alertService.displayError("No changes found to update");
    }
  }

  cancelEdit() {
    this.editAccessDialogRef.close();
  }

  disableSaveBtn() {
    if(!this.editAccessForm.valid) 
      return true; 
    if(!this.editAccessForm.touched && this.editAccessForm.pristine) 
        return true; 
    if(this.accessTypeField?.value === this.currentAccessType)
      return true;
    return false;
  }

  removeUserConfirmPopUp(element: any) {
    this.removeUserDialogRef = this.dialog.open(this.removeUserDialog, {
      width: '312px'
    });
    this.removeUserEmail = element.email;
    this.removeUserName = element.userName;
  }

  
  deleteUser() {
    if(this.removeUserEmail) {
      this.adminService.removeUser(this.orgId, this.removeUserEmail, this.userEmail, this.userId).subscribe({
        next: res => {
          if (res.Errors.length > 0) {
            this.alertService.displayError("Error occurred while Removing User " + res.ErrorMessage);
          } else {  
            this.alertService.displaySuccess("User has been removed successfully");
            this.retrieveUserData();
            this.removeUserDialogRef.close();
          }
        },
        error: error => {
          this.alertService.displayError("Error occurred while Removing User " + error.message);
        }  
      });
    }
  }

  cancel() {
    this.removeUserDialogRef.close();
  }

  addNewUserPopup() {
    this.initializeAddUserForm();
    this.accessTypesList = AccessTypesList;
    this.addUserErrorEmail = '';
    this.addUserDialogRef = this.dialog.open(this.addUserDialog, {
      width: '700px'
    });
  }

  initializeAddUserForm() {
    this.addUserForm = this.formBuilder.group({
      firstName: [ '', Validators.required],
      lastName: [ '', Validators.required],
      emailAddress: [ '', [Validators.required, Validators.email]],
      accessType: [ 'USAN User', Validators.required],
    });
  }

  disableAddBtn() {
    if(!this.addUserForm.valid) 
      return true; 
    if(!this.addUserForm.touched && this.addUserForm.pristine) 
      return true; 
    if(this.addUserErrorEmail != this.addUserForm.get('emailAddress')?.value)
      return false;
    if(this.addUserHasError)
      return true;
    return false;
  }

  addNewUser() {
    let roleName : RoleObject = {
      roleName : this.addUserForm.get('accessType')?.value
    }
    let request : AddNewUserRequest = {
      firstName : this.addUserForm.get('firstName')?.value,
      lastName : this.addUserForm.get('lastName')?.value,
      emailAddress : this.addUserForm.get('emailAddress')?.value,
      role : [roleName]
    }
    this.addUserHasError = false;
    this.addUserErrorMsg = '';
    this.adminService.addNewUser(this.orgId, request, this.userEmail, this.userId).subscribe({
      next: res => {
        if (res.ErrorMessage) {
          this.alertService.displayError("Error occurred while Adding New User " + res.ErrorMessage);
          this.addUserHasError = true;
          this.addUserErrorMsg = res.ErrorMessage;
        } else {  
          this.alertService.displaySuccess("User has been added successfully");
          this.retrieveUserData();
          this.addUserDialogRef.close();
        }
      },
      error: error => {
        let respError = error?.error?.ErrorMessage; 
        this.addUserHasError = true;
        this.addUserErrorMsg = this.parseExceptionMessage(respError);
        this.addUserErrorEmail = this.addUserForm.get('emailAddress')?.value;
        this.alertService.displayError("Error occurred while Adding User " + error.message);
      }  
    }); 
  }

  parseExceptionMessage(errMsg : string) :string {
    if(errMsg.includes(': "')) {
      let errorStr = errMsg.split(': "')[1];
      let errorObjStr = errorStr.substring(0, errorStr.length-1)
      let obj = JSON.parse(errorObjStr)
      return obj.ErrorMessage;
    }
    return errMsg;
  }

  cancelAdd() {
    this.addUserDialogRef.close();
  }

  onPageChange(event: PageEvent) {
    this.pageCardSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updateItemsForPagination();
  }
  
  updateItemsForPagination() {
    const start = this.currentPage * this.pageCardSize;
    const end = start + this.pageCardSize;
    this.appCardDataPag = this.appCardData.slice(start, end);
  }

  onPageChangeForUsers(event: PageEvent) {
    this.userPageSize = event.pageSize;
    this.userCurrentPage = event.pageIndex;
    this.updateUserItemsForPagination();
  }

  updateUserItemsForPagination() {
      const start = this.userCurrentPage * this.userPageSize;
      const end = start + this.userPageSize;
      this.userDataPag = this.userTableData.slice(start, end);
      this.usersList.data = this.userDataPag;
  }

  ngOnDestroy(): void {
    this.screenSizeSubscription.unsubscribe();
  }

  //to announce the change in sort state for assistive technology
    sortChangeUpdate(sortChange: Sort) {
      if(sortChange.direction) {
        this.sortAnnouncer.announce('Sorted '+ sortChange.direction);
      } else {
        console.log('Sort cleared');
        this.sortAnnouncer.announce('Sort cleared');
      }
    }

  userSortChangeUpdate(sortChange: Sort) {
    const data = [... this.userTableData];
    let column = sortChange.active;
    let dir = sortChange.direction;
    if (!column || dir === '') {
      //no change
      return;
    }
    const isAsc = dir ==='asc';
    this.userTableData = data.sort((a,b) => {
      let aValue = typeof a[column] === 'string' ? a[column].toLowerCase() : a[column];
      let bValue = typeof b[column] === 'string' ? b[column].toLowerCase() : b[column];
      return this.compareValues(aValue, bValue, isAsc);
      
    });
    this.updateUserItemsForPagination();
    if(sortChange.direction) { //to announce sorting change for assistive technology
      this.sortAnnouncer.announce('Sorted '+ sortChange.direction);
    } else {
      this.sortAnnouncer.announce('Sort cleared');
    }
  }

  compareValues( a: string|number, b: string|number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mapDataBasedOnCaseStatus(data: ApplicationTableData[], status: string) : ApplicationTableData[] {
    var dataArray : ApplicationTableData [] = [];
    for(let d of data) {
      if(d.status?.toLowerCase() === status.toLowerCase())
        dataArray.push(d);
    }
    return dataArray;
  }

  selectAppTypeChange(appType: MatTabChangeEvent) {
    this.loadingComplete = false;
    let appTypeSelected = this.appTypes[appType.index];
    if(appTypeSelected.includes('Approved'))
      appTypeSelected = 'Approved'; //Approved will also include Closed cases as well
    this.retrieveApplications(appTypeSelected);
  }

  

}